import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type { ActionWithAssignees, OncePer } from '../../../shared/domain/schedule/types.no-deps'

export const route: Route = { method: 'PATCH', pattern: '/api/actions/:id' }

interface ActionEdit {
    dueDate?: Date
    description?: string
    users?: number[]
    teams?: number[]
    oncePer?: OncePer
    subjectUnitIds?: number[]
}

interface NonWorkflowActionEdit extends ActionEdit {
    workflow?: null
    procedure?: null
}

interface WorkflowActionEdit extends ActionEdit {
    workflow: number
    procedure: number
}

export function isWorkflowAction(action: NonWorkflowActionEdit | WorkflowActionEdit): action is WorkflowActionEdit {
    return Boolean((action as WorkflowActionEdit).workflow && (action as WorkflowActionEdit).procedure)
}

type Params = { id: UUID }
type Body = NonWorkflowActionEdit | WorkflowActionEdit
type Query = never
type Output = ActionWithAssignees

export type EditEndpoint = Endpoint<Params, Body, Query, Output>

export const editRequest = (request: Request, args: RequestArgs<EditEndpoint>) => request<EditEndpoint>(route, args)
